import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUsers,
  faChevronDown,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import UserCard from "./UserCard";
import { formatDateOnly } from "../../utils/DateTimeUtil";

// SECURITY: This component uses groupName as identifier instead of groupId
function GroupSection({
  group,
  isDirectGroup = false,
  isExpanded,
  onToggle,
  onUserAssignmentClick,
}) {
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return formatDateOnly(dateString, "short");
  };

  // SECURITY: Use groupName as identifier
  const groupName = group.groupName || group.name;

  return (
    <div className="common-section group-section">
      <div
        className="common-section-header group-header"
        onClick={() => onToggle(groupName)}
      >
        <div className="header-content">
          <FontAwesomeIcon
            icon={isExpanded ? faChevronDown : faChevronRight}
            className="expand-icon"
          />
          <FontAwesomeIcon icon={faUsers} className="section-icon" />
          <div className="header-text">
            <h4>{group.name || group.groupName}</h4>
            <p>{group.description || "No description"}</p>
            <span className="user-count">
              {group.userCount} user{group.userCount !== 1 ? "s" : ""}
            </span>
          </div>
        </div>
      </div>

      {isExpanded && (
        <div className="common-section-content">
          <div className="common-form-group">
            <h4>Group Information</h4>
            <div className="account-info-grid">
              <div className="info-item">
                <label>Group Name:</label>
                <span>{group.name || group.groupName}</span>
              </div>
              <div className="info-item">
                <label>Created:</label>
                <span>{formatDate(group.createdAt)}</span>
              </div>
              {isDirectGroup && (
                <div className="info-item">
                  <label>Type:</label>
                  <span>Direct Account Group</span>
                </div>
              )}
            </div>
          </div>

          <div className="common-form-group">
            <h4>Users in this group ({group.userCount})</h4>
            {group.users && group.users.length > 0 ? (
              <div className="users-container">
                {group.users.map((user) => (
                  <UserCard
                    key={user.uuid}
                    user={user}
                    onUserAssignmentClick={onUserAssignmentClick}
                  />
                ))}
              </div>
            ) : (
              <div className="info-note">No users in this group</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default GroupSection;
